/* Translation with Dictionary |  Initialization */
import { useEffect, useState } from 'react'
import { locale } from 'primereact/api'
import moment from 'moment'
import i18next from 'i18next'

// local imports
import DictionaryManagementService from 'service/DictionaryService'

let language = localStorage.getItem('lang') || 'tr'
let dictionaryTr = ''
let dictionaryEn = ''

export default function useDictionary() {
  const [dictionaryLoading, setDictionaryLoading] = useState(false)

  const loadResources = async () => {
    return await DictionaryManagementService.getDictionaryList()
      .then((response) => {
        return response?.data
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const backendOptions = {
    loadPath: '{{lng}}|{{ns}}',
    request: () => {
      try {
        setDictionaryLoading(true)
        loadResources().then((response) => {
          let dictTr = response?.map((item) => ({ [item.keyword]: item.tr })) || []
          let dictEn = response?.map((item) => ({ [item.keyword]: item.en })) || []
          dictionaryTr = Object.assign({}, ...dictTr)
          dictionaryEn = Object.assign({}, ...dictEn)
          i18next.addResourceBundle('tr', 'dictionary', dictionaryTr, true, true)
          i18next.addResourceBundle('en', 'dictionary', dictionaryEn, true, true)
          setDictionaryLoading(false)
        })
      } catch (e) {
        console.error(e)
      } finally {
        setDictionaryLoading(false)
      }
    },
  }

  useEffect(() => {
    moment.locale('tr')
    locale(language === 'tr' || language === 'tr-TR' ? 'tr' : 'en')
    if (!window.location.pathname.includes('login') && !window.location.pathname.includes('logout')) {
      backendOptions.request()
    }
    window.scrollTo(0, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { dictionaryLoading }
}
